require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/entries.js
// module id = 1456
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16